<template>
  <vk-modal class="WARNING-MODAL" v-on="$listeners">
    <vk-modal-body class="bg-transparent">
      <transition name="WARNING-SLIDE" appear>
        <vk-modal-content class="WARNING-MODAL-CONTENT p-0">
          <vk-modal-close class="WARNING-CLOSE"/>
          <slot/>
        </vk-modal-content>
      </transition>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
export default {
  name: 'warning-modal',
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.WARNING-MODAL {
  $modal-border-y: 5*$unit;
  $modal-border-x: 3*$unit;

  border-width: $modal-border-y $modal-border-x;
  border-color: transparent;
  border-style: solid;
}

.WARNING-MODAL-CONTENT {
  transition: background-color $transition-speed-standard ease;
  display: flex;
  position: relative;
  text-align: center;
  background-color: transparent;
  overflow: visible !important;
}

.WARNING-CLOSE {
  @include absolute($top: 0, $right: 0);
  @include padding(2); // for larger click area
  @include h5;
  z-index: 1;
  color: white;

  @include tablet {
    color: inherit;
  }
}

// Wait slightly before entering
.WARNING-SLIDE-enter-active {
  animation: warning-slide 0.5s;
}

@keyframes warning-slide {
  0% {
    opacity: 0;
    transform: translate3d(0, 100vh, 0);
  }
  30% {
    opacity: 0;
    transform: translate3d(0, 100vh, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

</style>
